import GoogleLoginProvider from "adminUsers/GoogleLoginProvider";
import { redirect_to_next } from "base/functions";
import Message from "base/Message";
import Page from "webPage/Page";

Page.register('/login', () => {
    GoogleLoginProvider.initialise().then(() => {
        $(".js-google-login").removeAttr("disabled");
    });

    $("body").on("click", ".js-google-login", function () {
        if ($(this).is('.admin-btn--loading')) {
            return;
        }
        $(this).addClass('admin-btn--loading');

        GoogleLoginProvider.authenticate().then(() => {
            redirect_to_next('/');
        }).catch((e) => {
            console.warn("Login error", e);
            $(this).removeClass('admin-btn--loading');
            let message = e.message;

            if (e.error) {
                if (e.error === "popup_closed_by_user") {
                    // Don't display an error
                    return;
                } else {
                    message = "An error occurred when authenticating with Google. Please try again.";
                }
            }
            new Message(message);
        });

        return false;
    });
});
